import { CircleRounded, InsertDriveFileRounded } from '@mui/icons-material';
import { Box, Stack, Typography, alpha, useTheme } from '@mui/material';
import { Playstore, Twitter } from 'common/Icons/Icons';

export const SelectedMetadataFieldsListEmptyState = () => {
  const theme = useTheme();

  function renderMetadataPlaceholderBox(
    icon: React.ReactNode,
    opacity: number,
    width: string,
  ) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          p: 2,
          width: width,
          bgcolor: (theme) => alpha(theme.palette.background.paper, 0.5),
          borderRadius: 3,
          opacity: opacity,
        }}
      >
        {icon}
        <Typography>Metadata</Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2} px={2} mt={2}>
      <Typography variant="subtitle1" color="text.secondary" mx={2}>
        No metadata selected to unify with the above metadata field.
      </Typography>

      <Stack spacing={1}>
        {renderMetadataPlaceholderBox(<InsertDriveFileRounded />, 0.5, '100%')}
        {renderMetadataPlaceholderBox(
          <Playstore fill={theme.palette.text.primary} />,
          0.3,
          '85%',
        )}
        {renderMetadataPlaceholderBox(<CircleRounded />, 0.2, '70%')}
        {renderMetadataPlaceholderBox(
          <Twitter fill={theme.palette.text.primary} />,
          0.1,
          '55%',
        )}
      </Stack>
    </Stack>
  );
};
